import * as Sentry from '@sentry/vue'

class Hotjar {
  constructor(tracker) {
    this.tracker = tracker
  }

  identifyUser(payload = {}) {
    const {
      email,
      plan,
      signedUpAt,
      userId,
      numberOfPresentations,
      country,
      lastEventStartedAt,
      abTestGroup,
      accountId,
      accountRole,
    } = payload

    try {
      this.tracker('identify', userId, {
        plan,
        email,
        signed_up_at: signedUpAt,
        number_of_presentations: numberOfPresentations,
        country,
        lastEventStartedAt,
        abTestGroup,
        accountId,
        accountRole,
      })
    } catch (e) {
      // Should not break the app if something goes wrong with Hotjar
      // But should track the error to Sentry to know why this happened
      Sentry.captureException(e, {
        extra: {
          email,
          plan,
          signedUpAt,
          userId,
          numberOfPresentations,
          country,
          lastEventStartedAt,
          abTestGroup,
          accountId,
          accountRole,
        },
      })
    }
  }

  trackEvent(eventName) {
    try {
      this.tracker('event', eventName)
    } catch (e) {
      // Should not break the app if something goes wrong with Hotjar
      // But should track the error to Sentry to know why this happened
      Sentry.captureException(e, {
        extra: {
          eventName,
        },
      })
    }
  }
}

export default new Hotjar(window.hj)
